import React, { Fragment } from 'react'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type ForgotPasswordData = {
    phoneOrEmail:string
}

type ForgotPasswordModalProps = {
    show:boolean,
    setShow: (val:boolean)=>void,
    handleForgotPassword:({}:ForgotPasswordData)=>void
}

/**
 * As this model works on isFirstLogin flag, but until user dont logout and login again, isFirstLOgin is not going to set false
 * so this popup will come everytime user refresh the page. So to handle that, 
 * on this popop close, an action has been called that deleted isFirstLOgin key from currentuser in auth store.
 * When user login again, it wll be automatically false, so this popup wont render again 
 */

function ForgotPasswordModal({ show = false, setShow, handleForgotPassword}: ForgotPasswordModalProps) {

  const { register, handleSubmit, formState: { errors } } 
    = useForm<{phoneOrEmail:string}>()

  const {t}=useTranslation("")
  
  return (
    <>
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        centered
        className="addCardFormModal"
      >
        <Modal.Body className='m-3 p-2'>
          <a href={void 0} className="closeButton" style={{float:"right"}} onClick={
            () => { setShow(false); }
          } >
            <em className="fa-solid fa-close"></em>
          </a>
          <div className="text-center stepOne mt-3 pt-3">
            <h4 className="mb-3 _title pb-3">{t("ForgetPasswordModal.title")}</h4>
            </div>
          <div className=" stepOne">
            <p className='text-center mb-3'>{t("ForgetPasswordModal.emailText")}</p>

            <form onSubmit={handleSubmit(handleForgotPassword)}>
                
                <div className="form-floating mb-3">
                    <input
                        type="text"
                        className="form-control"
                        id="email"
                        placeholder={t("ForgetPasswordModal.placeholder")}
                        {...register("phoneOrEmail", { required: true, pattern: /^\S+@\S+$/i })}
                    />
                    {errors.phoneOrEmail?.type == "required" && <span className="m-2 isInvalidMessage text-danger">{t("ForgetPasswordModal.errors.requiredError")}</span>}
                    {errors.phoneOrEmail?.type == "pattern" && <span className="m-2 isInvalidMessage text-danger">{t("ForgetPasswordModal.errors.validEmailError")}</span>}
                    <label htmlFor="email">{t("ForgetPasswordModal.label")}</label>
                </div>
            
                {/* <p>{t("ReferralCreditModal.congratsTextFirstPart")} ${credits} {t("ReferralCreditModal.congratsTextSecondPart")}</p> */}
                <div className='text-center'>
                    <button
                        type="submit"
                        className="button button-primary button-rounded button-sm px-3 button-min-120 fontsize-14 fw700"
                        //   onClick={() => { dispatch(authActions.removeFirstLoginKey()); navigate('/account/referral') }}
                        >
                        {t("ForgetPasswordModal.btnText")}
                    </button>
                </div>
                
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>

  )
}

export default ForgotPasswordModal;



